import user from './reducers/user';

export const reducerList = {
	// Add your reducers here
	user
};

export default reducerList;
